import { Box } from '@mui/material';
import React, { useState } from 'react';
import useWebContext from '../../hooks/useWebContext';
import { MyMButton, MyMCloseButton } from '../../ui-elements/MyMButton';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMLink } from '../../ui-elements/MyMLink';
import { MyMModal } from '../../ui-elements/MyMModal';
import { PagingDataGrid } from '../../ui-parts/PagingDataGrid';
import { utility } from '../../utility';
import { FileUpload } from '../MyM602_FIleUpload/FileUpload';
import { constants } from '../../constants';
import { useTheme } from '@mui/material/styles';

export const FileManagementSearchResult = React.memo((props) => {
  const {
    screenId,
    resultPageInfo,
    sortModel,
    setSortModel,
    isFileListLoading,
    pageNumber,
    setPageNumber,
  } = props;
  const { controlSettings, messageList } = useWebContext(screenId);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const theme = useTheme();
  const handleModalClose = () => {
    setIsModalOpen(false);
  }
  const [fileId, setFileId] = useState('');

  const handlePageChange = (pageNum) => {
    setPageNumber(pageNum);
  };

  const handleSortModelChange = (sortModel) => {
    setSortModel(sortModel);
  };

  const columns = [
    {
      field: 'NAME_DISP',
      headerName: controlSettings.LabelList.lblFileNameDisplayHeader,
      minwidth: 100,
      flex: 2,
      sortable: true,
      renderCell: (params) => <MyMLink onClick={() => openModal_FileUpload(params.row.id)} sx={{ textAlign: 'left', wordBreak: 'break-all' }}>{params.row.NAME_DISP}</MyMLink>,
    },
    {
      field: 'NAME_ORGN',
      headerName: controlSettings.LabelList.lblFileNameOriginalHeader,
      minwidth: 100,
      flex: 2,
      sortable: true,
      renderCell: (params) => <MyMLabel >{params.row.NAME_ORGN}</MyMLabel>,
    },
    {
      field: 'EXTENSION',
      headerName: controlSettings.LabelList.lblFileTypeHeader,
      minwidth: 100,
      flex: 0.7,
      sortable: true,
    },
    {
      field: 'FILE_SIZE',
      headerName: controlSettings.LabelList.lblFileSizeHeader,
      minwidth: 100,
      flex: 0.7,
      sortable: true,
      renderCell: (params) => <MyMLabel sx={{ display: 'block', textAlign: 'right', width: '100%' }}>{params.row.FILE_SIZE}</MyMLabel>
    },
    {
      field: 'UPLOAD_USER_NAME',
      headerName: controlSettings.LabelList.lblUploadbyHeader,
      minwidth: 100,
      flex: 1,
      sortable: true,
    },
    {
      field: 'UPLOAD_DATE',
      headerName: controlSettings.LabelList.lblUploadDateHeader,
      minwidth: 100,
      flex: 0.7,
      sortable: true,
      type: 'datetime',
      renderCell: (params) => <MyMLabel sx={{ display: 'block', textAlign: 'right', width: '100%' }}>{utility.formatDate(params.row.UPLOAD_DATE)}</MyMLabel>
    },
    {
      field: 'PRODUCT_TYPE',
      headerName: controlSettings.LabelList.lblMetadataProductTypeHeader,
      minwidth: 100,
      flex: 1.5,
      sortable: true,
      renderCell: (params) => <MyMLabel>{params.row.PRODUCT_TYPE}</MyMLabel>,
    },
    {
      field: 'BUSINESS_AREA',
      headerName: controlSettings.LabelList.lblMetadataBusinessAreaHeader,
      minwidth: 100,
      flex: 1.5,
      sortable: true,
      renderCell: (params) => <MyMLabel>{params.row.BUSINESS_AREA}</MyMLabel>,
    },
    {
      field: 'DOWNLOAD_COUNT',
      headerName: controlSettings.LabelList.lblMetadataDownloadCountHeader,
      minwidth: 100,
      flex: 1,
      sortable: true,
      type: 'datetime',
      renderCell: (params) => <MyMLabel sx={{ display: 'block', textAlign: 'right', width: '100%' }}>{params.row.DOWNLOAD_COUNT}</MyMLabel>
    },
  ];

  // 2024.5.8 MyMine Version1.5対応 Add Start
  columns.forEach(x => x.cellClassName = 'align-items-center d-flex');
  // 2024.5.8 MyMine Version1.5対応 Add End

  const openModal_FileUpload = (props) => {
    setIsModalOpen(true);
    setFileId(props);
  }

  return (
    <Box sx={{ width: '100%', padding: '25px 40px 0px 40px' }}>
      <Box sx={{ marginBottom: '10px' }}>
        <MyMButton onClick={() => { openModal_FileUpload('') }}>{controlSettings.LabelList.btnAddNew}</MyMButton>
      </Box>
      <>
        <Box sx={{
          padding: '0 10px',
          height: '50px',
          width: '26.5%',
          marginLeft: '64%',
          backgroundColor: theme.palette.background.secondary,
          color: 'white',
          borderRadius: '4px 4px 0 0',
          display: 'flex',
          alignItems: 'center',
        }}>
          <MyMLabel className='fw-medium'>{controlSettings.LabelList.lblMetadata}</MyMLabel>
        </Box>
        <Box sx={{ height: '57vh' }}>
          <PagingDataGrid
            // DataGrid用
            columns={columns}
            dataList={resultPageInfo.ItemList.map((row) => {
              return {
                id: row.FileId,
                NAME_DISP: row.NameDisp,
                NAME_ORGN: row.NameOrgn,
                EXTENSION: row.Extension,
                // ファイルサイズをMBに変換し単位を追加
                FILE_SIZE: row.FileSize !== null ?
                  utility.convertFileSize(row.FileSize, constants.FileSize.MB)?.toFixed(2) + controlSettings.LabelList.lblFileSizeUnit :
                  '',
                UPLOAD_USER_NAME: row.UploadUserName,
                UPLOAD_DATE: row.UploadDate,
                MODEL: row.Model,
                PRODUCT_TYPE: row.ProductType,
                BUSINESS_AREA: row.BusinessArea,
                DOWNLOAD_COUNT: row.DownloadCount,
              }
            })}
            uniquyKey={(row) => row.id}
            handleSortModelChange={handleSortModelChange}
            loading={isFileListLoading}
            getRowHeight={() => 'auto'}
            sx={{ borderTop: 'none', marginBottom: '5px', '[role=gridcell]': {displey: 'flex !important', alingItems: 'center !important'} }}
            sortModel={sortModel}
            // 2024.5.8 MyMine Version1.5対応 Add Start
            disableColumnResize={true}
            // 2024.5.8 MyMine Version1.5対応 Add End
            // Pager用
            resultListItem={resultPageInfo}
            handlePageChange={handlePageChange}
            labelList={controlSettings.LabelList}
            messageList={messageList}
            pageNumber={pageNumber}
          />
        </Box>
      </>
      <Box align='right' marginTop='1rem' marginRight='1rem'>
        <MyMCloseButton closeText={controlSettings.LabelList.btnClose} />
      </Box>
      <MyMModal
        open={isModalOpen}
        onClose={handleModalClose}
        width='80%'
        height='93%'
      >
        <FileUpload fileId={fileId} handleModalClose={handleModalClose} />
      </MyMModal>
    </Box>
  )
}
)